// ClientApp/src/apps/components/tests/SsoAuthVerificationFlow/components/PortalIdentitySection.jsx
import PropTypes from "prop-types";

export default function PortalIdentitySection({ statusMsg, portalUser }) {
  return (
    <div className="sso-auth-flow__section sso-auth-flow__section--portal">
      <h3>Step 1: BOGS Identity (from BOGS ArcGIS Portal, Geoplatform)</h3>
      <p>
        <strong>Status Message:</strong> {statusMsg}
      </p>
      {portalUser && (
        <>
          <p>
            <strong>Name:</strong> {portalUser.fullName}
          </p>
          <p>
            <strong>Email to be Used:</strong>{" "}
            <span className="sso-auth-flow__email-highlight">{portalUser.email}</span>
          </p>
          <p>
            <strong>Provider:</strong> {portalUser.provider}
          </p>
        </>
      )}
    </div>
  );
}

PortalIdentitySection.propTypes = {
  statusMsg: PropTypes.string,
  portalUser: PropTypes.shape({
    fullName: PropTypes.string,
    email: PropTypes.string,
    provider: PropTypes.string,
  }),
};

PortalIdentitySection.defaultProps = {
  statusMsg: null,
  portalUser: null,
};